var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"card",attrs:{"id":_vm.id,"draggable":_vm.draggable},on:{"dragstart":_vm.dragStart,"dragend":_vm.dragEnded,"dragover":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }